<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let recObjectsStore = getGroupStore('recObjectsStore');
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');
  import Avatar from '@components/Avatar.svelte';
  import ComponentEvents from '@utils/component-events';

  import Review from '@app-components/rec_object/parts/Review.svelte';

  export let recObjectId;
  export let recIds;
  export let mobile = false;
  export let lines = 2;
  export let customGroupStore;
  export let forceShowNames = false;
  export let expand = false;

  const dispatch = createEventDispatcher();
  let recObject = recObjectsStore.find(recObjectId);
  let group = customGroupStore || groupStore;
  let recs = recIds.map((id) => recsStore.find(id)).filter((x) => x !== undefined);
  let rec = recs[0];
  let groupOwner;

  let expandMoreThanOne = false;
  let maxAvatars = 3;

  onMount(() => {
    groupOwner = group.users.filter((x) => x.role === 'admin');
    let unsubRecObject = recObject.subscribe((x) => (recObject = x));

    let unsubRecs = recsStore.subscribe((_x) => {
      recs = recIds.map((id) => recsStore.find(id)).filter((x) => x !== undefined);

      rec = recs[0];
    });

    return () => {
      unsubRecObject();
      unsubRecs();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .review-container {
    height: 52px;

    .single-review {
      margin-top: -10px;
      max-height: 490px;
      overflow-x: hidden;
      overflow-y: auto;
    }

    .expand {
      position: absolute;
      left: 0px;
      right: 0px;
      z-index: 3;
      padding-left: 30px;
      padding-right: 30px;
      background: white;
      border-radius: 15px;
      box-shadow: 0px 32px 40px rgba(0, 0, 0, 0.08);
      padding-bottom: 10px;
      margin-top: -52px;
    }
  }

  .container-expand {
    height: unset;
  }

  .multiple-recs {
    max-height: 40px;
    min-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    cursor: default;
    margin-top: -10px;
    padding-top: 20px;

    .single-avatar {
      width: 35px;
      flex-shrink: 0;
      margin-right: 8px;
    }

    .total-recommenders {
      margin-left: 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 12px;
      color: #8e71ff;
      cursor: pointer;

      &:hover {
        color: #7054dc;
      }
    }
  }

  .close-btn-review {
    float: right;
    cursor: pointer;

    &:before {
      content: '\2715';
    }
  }

  .mobile {
    .expand {
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 15px;
      border-radius: 0px;
    }
  }
</style>

<div class="review-container" class:mobile={mobile} class:container-expand={expand}>
  {#if recs.length > 1}
    <div class="multiple-recs">
      {#each recs as rec, i}
        {#if i < maxAvatars}
          <div class="single-avatar" data-rec-id={rec.id} data-user-id={rec.user.id}>
            <Avatar href={rec.user.profile_path} src={rec.user.avatar_url} width={35} user={rec.user} mobile={mobile} />
          </div>
        {/if}
      {/each}

      <a
        href="#"
        on:click|preventDefault|stopPropagation={() => {
          expandMoreThanOne = !expandMoreThanOne;
        }}
        class="total-recommenders">
        {recs.length} recommenders
      </a>

      {#if expandMoreThanOne}
        <div
          style="cursor: pointer; margin-left: 12px; margin-top: -5px;"
          on:click|preventDefault|stopPropagation={() => {
            expandMoreThanOne = false;
          }}>
          <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.06486 5.82617C1.4361 6.09134 1.98784 6.04835 2.29721
              5.73014L6 1.92154L9.70279 5.73014C10.0122 6.04835 10.5639 6.09134
              10.9351 5.82617C11.3064 5.56099 11.3565 5.08807 11.0472
              4.76986L6.67219 0.269862C6.50595 0.0988673 6.25968 0 6 0C5.74032 0
              5.49405 0.0988673 5.32781 0.269862L0.952828 4.76986C0.64346
              5.08807 0.693619 5.56099 1.06486 5.82617Z"
              fill="#A893F9" />
          </svg>
        </div>
      {/if}
    </div>

    {#if expandMoreThanOne}
      <div style="margin-bottom: -10px" />
      <div
        class="single-review purple-scrollbar expand"
        style="margin-top: 42px; padding-right: 30px; max-height: 410px;">
        {#each recs as rec}
          <Review
            customGroupStore={customGroupStore}
            id={rec.id}
            style="padding-left: 0px; padding-right: 0px;"
            showAvatar={false}
            maxHeight={99999} />
        {/each}
      </div>
    {/if}
  {:else if recs.length == 1}
    {#if expand}
      <div class="add-height-above-review" style="height: 42px;" />
    {/if}
    <div class="single-review purple-scrollbar" class:expand={expand}>
      <Review
        customGroupStore={customGroupStore}
        mobile={mobile}
        nameStyle="margin-top: 8px;"
        nameDescriptionStyle={mobile
          ? ''
          : 'margin-top: -8px; display: flex; align-items: center; width: 100%; margin-left: 15px; min-height: 55px;'}
        descriptionStyle="width: 100%;"
        arrowStyle="margin-top: 0px;"
        showNames={forceShowNames || (rec.permissions.edit ? false : !(rec.user_note && rec.user_note != ''))}
        viewStyle="grid"
        id={rec.id}
        lines={lines}
        on:focus={() => {
          dispatch('reviewsExpand', true)
          ComponentEvents.trigger('section-bar-disable-scroll-updates');
          dispatch('focus');
        }}
        on:blur={() => {
          dispatch('reviewsExpand', false)
          ComponentEvents.trigger('section-bar-enable-scroll-updates');
          dispatch('blur');
        }}
        on:expanded={() => {
          dispatch('reviewsExpand', true)
        }}
        on:collapsed={() => {
          dispatch('reviewsExpand', false)
        }}
        on:click={() => {
          dispatch('click');
        }} />
    </div>
  {:else if groupOwner}
    <div style="align-items: center; display: flex;">
      <Avatar href="/profiles/1" src={groupOwner.avatar_url} width={40} user={groupOwner} mobile={mobile} />

      <div style="margin-left: 14px; flex: 1; font-weight: 500;">
        {groupOwner.name}
      </div>
    </div>
  {/if}
</div>
